/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown> }} Admin_Subscription_Rights_Usage_PeriodInputs */

const fr_admin_subscription_rights_usage_period = /** @type {(inputs: Admin_Subscription_Rights_Usage_PeriodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du ${i?.start} au ${i?.end}`)
};

/**

* @param {Admin_Subscription_Rights_Usage_PeriodInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_usage_period = /** @type {((inputs: Admin_Subscription_Rights_Usage_PeriodInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_Usage_PeriodInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_usage_period(inputs)
});